import { useEffect, useState } from 'react';
import { fetchSoftDeletedNames } from './renameFolderHelpers';

export const useSoftDeletedNames = (currentPath, enabled = true) => {
  const [softDeletedNames, setSoftDeletedNames] = useState([]);

  useEffect(() => {
    if (!enabled) {
      setSoftDeletedNames([]);
      return undefined;
    }

    let cancelled = false;

    const loadSoftDeletedNames = async () => {
      try {
        const names = await fetchSoftDeletedNames(currentPath);
        if (!cancelled) {
          setSoftDeletedNames(names);
        }
      } catch {
        if (!cancelled) {
          setSoftDeletedNames([]);
        }
      }
    };

    loadSoftDeletedNames();

    return () => {
      cancelled = true;
    };
  }, [currentPath, enabled]);

  return softDeletedNames;
};
